//import SectionPreloader from '../SectionPreloader'
import { useEffect, useState } from 'react'
import ListItem from '../list/ListItem'
import dayjs from 'dayjs'
import { orderBy } from 'lodash'

const EventList = ({isTop, category, type, date, events, setDate}) => {
  const [showMore, setShowMore] = useState(false);
  const [showFromToday, setShowFromToday] = useState(true);
  const now =  dayjs();
  let eventsToShow = null;

  useEffect(()=> {
    //KPOPとTVは日付限定なのでとりあえず一月分は全部表示する
    if(category==='tv' || category==='kpop'){
      setShowMore(true);
      setShowFromToday(false);
    }
  }, [category])

  if(date && !!events && events[date]) {
    const events_ = orderBy(events[date], ['date', 'eventTime'], ['asc', 'asc']);
    eventsToShow = {};
    events_.map((ev, i) => {
      if (!eventsToShow[ev.date]) eventsToShow[ev.date] = [];
      eventsToShow[ev.date].push(ev);
    })
  }


  const filterByNow=()=> {
    let filtered = type==='news' ? Object.keys(eventsToShow).slice(0).reverse() : Object.keys(eventsToShow);
    if(type==='posts' && isTop && showFromToday){
      const same_month = dayjs(date).diff(now, 'month');
      if(same_month===0) filtered = filtered.filter(d => d && dayjs(d).diff(now, 'day')>=0);
      if(!showMore) filtered = filtered.slice(0, 2);
    }
    return filtered;
  }

  const callPrevDate=()=> {
      const [y, m] = date.split("-");
      let m2 = parseInt(m);
      let y2 = parseInt(y);
      if(m2===1) {
        y2 -= 1;
        m2 = 12;
      } else {
        m2 -= 1;
      }
      if(!!setDate ) setDate(y2+"-"+('0'+m2).slice(-2));
  }


  return (
      <div className="months">
          {
            eventsToShow && Object.keys(eventsToShow).length>0 ? filterByNow().map((yearMon, i) => {
              return (
                <div className="month" key={'events_by_day' + i}>
                    <div className="day">
                   <p className="date">
                     <span className="date m"> {dayjs(yearMon).format('MM/DD(ddd)')}</span>
                     {
                       yearMon===now.format("YYYY-MM-DD") && <span className="date m today">TODAY</span>
                     }
                   </p>
                    </div>
                  <div className="day-items">
                  {
                    eventsToShow[yearMon] && eventsToShow[yearMon].map((ev, i) => <ListItem key={'ev' + i} item={ev} type={type}/>)
                  }
                  </div>
                  </div>)
            }) :  setDate ? <div className="event_not_found">{date}の情報が見つかりません <button onClick={callPrevDate}>前の月を確認する</button></div> : <div/>
          }

        {
          !showMore && type==='posts' && <div className="show_more" onClick={()=> setShowMore(true)}>
            <img src="https://towershibuya.jp/assets/images/common/showmore_btn.png" alt="more"/>
          </div>
        }
        </div>
  )
}

export default EventList;
